import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';

// Importaciones de componentes.
import { PasswordSettingsComponent } from './password-settings.component';

@NgModule({
  declarations: [PasswordSettingsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class PasswordSettingsModule {}
